
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { SettlementModel } from 'models/generated/Entities.GormCrm.Settlement';
import { SettlementPaymentModel } from 'models/generated/Entities.GormCrm.SettlementPayment';


const _gormCrm_SettlementsControllerHelper = new Map<string, Object>();
_gormCrm_SettlementsControllerHelper.set('GetAllSettlements', SettlementModel);
_gormCrm_SettlementsControllerHelper.set('GetSettlement', SettlementModel);
_gormCrm_SettlementsControllerHelper.set('GetSettlementsByProductPlanId', SettlementModel);
_gormCrm_SettlementsControllerHelper.set('GetSettlementsByCompanyId', SettlementModel);
_gormCrm_SettlementsControllerHelper.set('CreateSettlement', SettlementModel);
_gormCrm_SettlementsControllerHelper.set('AcceptSettlement', SettlementModel);
_gormCrm_SettlementsControllerHelper.set('CreateSettlementPayment', SettlementPaymentModel);


export const gormCrm_SettlementsControllerHelper = _gormCrm_SettlementsControllerHelper;

